/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter, Route, Redirect} from 'react-router-dom';
import Header from './base/Header';
import Footer from './base/Footer';
import AuthModal from './base/login';
import PostJobContainer from './postjob/PostJobContainer';


class App extends Component {
    render() {
        return (
            <div style={{ height: '100%' }}>
                <Header />
                <Route path="/job/create" render={() => <PostJobContainer mode="postjob" />} />
                <Route path="/job/edit/:jobId" render={() => <Redirect to="/" />} />
                <Footer />
                <AuthModal forceModal={true} />
            </div>
        );
    }
}

// App.propTypes = {children: PropTypes.object};

function mapStateToProps(state) {
    return {};
}

export default withRouter(connect(mapStateToProps, {})(App));

// export default App;
